import { SITE } from '@/app/constants';

// 视频项配置
export const videoItemsConfig = [
  {
    id: '1',
    className: 'absolute top-[3%] left-[5%] w-[27%] sm:w-[35%] sm:left-[40%]',
    custom: 0.2,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/media-asset/template1-a3871cf5.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/template1-a3871cf5.webp',
    viewport: { once: true, amount: 0.5 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/template/095101-ALSj2p44vgsSlhix.mp4'
        : 'https://image01.vidu.zone/vidu/template/094217-bgwSp78MqrAf89DO.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
  {
    id: '2',
    className: 'absolute top-[0%] right-[20%] w-[18%] sm:w-[60%] sm:right-[50%] sm:top-[10%]',
    custom: 0.1,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/media-asset/template2-d00aa5ec.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/template2-d00aa5ec.webp',
    viewport: { once: true, amount: 0.5 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/template/095646-X5UcGAj6dstrVX3i.mp4'
        : 'https://image01.vidu.zone/vidu/template/085539-v8j8fW9VempM2W6r.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
  {
    id: '3',
    className: 'absolute top-[30%] right-[40%] w-[10%] sm:right-[-10%] sm:top-[20%] sm:w-[30%]',
    custom: 0.1,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/media-asset/template3-2929203a.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/template1-a3871cf5.webp',
    viewport: { once: true, amount: 0.6 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/template/102017-RWqVSK5tWegDwrtU.mp4'
        : 'https://image01.vidu.zone/vidu/template/092919-jl9LU9AvnaHgjuSA.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
  {
    id: '4',
    className: 'absolute top-[43%] right-[25%] w-[14%] sm:top-[50%] sm:right-[40%] sm:w-[32%]',
    custom: 0.1,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/media-asset/template4-865182e8.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/template3-2929203a.webp',
    viewport: { once: true, amount: 0.5 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/template/095321-XuzCopxVHsMJk86b.mp4'
        : 'https://image01.vidu.zone/vidu/template/093432-aMmGV713dj5IACBg.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
  {
    id: '6',
    className: 'absolute bottom-[10%] right-[0%] w-[25%] sm:hidden',
    custom: 0.1,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/landing-page/tamplate5.f38394d1.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/chineseWomen-578147cd.webp',
    viewport: { once: true, amount: 0.5 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/template/053228-BoNeedLtLct7BRkX.mp4'
        : 'https://image01.vidu.zone/vidu/landing-page/chineseWomen.e57013f7.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
  {
    id: '8',
    className: 'absolute bottom-[10%] left-[40%] w-[19%] sm:hidden',
    custom: 0.1,
    poster:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/media-asset/tamplate3-08aa58fc.webp'
        : 'https://image01.vidu.zone/vidu/media-asset/tamplate3-08aa58fc.webp',
    viewport: { once: true, amount: 0.5 },
    videoSrc:
      SITE === 'global'
        ? 'https://image01.cf.vidu.studio/vidu/landing-page/tamplate3.45cf65a3.mp4'
        : 'https://image01.vidu.zone/vidu/landing-page/tamplate3.45cf65a3.mp4',
    transition: { duration: 0.8, ease: 'easeOut', delay: 0.6 },
  },
];
